module.exports = __webpack_public_path__ + "img/asia-logo.a624973c.png";